var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"component":_vm.$options.name}},[_c('v-dialog',{attrs:{"value":true,"persistent":"","width":"300"}},[_c('v-card',[_c('v-card-text',[_vm._v(" Authenticating... "),_c('v-progress-linear',{staticClass:"mt-2 mb-0",attrs:{"indeterminate":"","color":"primary"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }